<template>
  <div class="info-section-6">

    <div class="laptop-asset-container">
      <img class="asset-mockup" src="../assets/mockup-images/mac-mockup.png" alt="">
      <div class="image-container image-tint">
        <img src="../assets/mockup-images/crowdfunding.jpg" alt="">
      </div>
    </div>

    <div class="info-container">

      <product-title
        main-title="New way of financing"
        :is-right=true
      />

      <info-box
        boxTitle="Be part of the change - DONATE"
        boxContent="eCrowd.mk, as a platform gives non-profit organizations the tool to finance their projects of social interest by collecting small donations from individuals. eCrowd.mk is easy to use, safe and reliable platform."
      />

    </div>

  </div>
</template>

<script>
import LogoHeader from "../components/LogoHeader";
import LeadTitle1 from "../components/sideMenu/LeadTitle1";
import ProductTitle from "../components/productComponents/ProductTitle";
import InfoBox from "../components/productComponents/InfoBox";

export default {
  name: 'InfoSection6',
  components: {InfoBox, ProductTitle, LeadTitle1, LogoHeader},
}
</script>

<style lang="scss">
@import "InfoSection6.scss";
</style>
